import { authApi } from './authApi';

// Notice Generation settings
export const fetchDraftAutomationStatus = async (): Promise<any> => {
  return await authApi.get('stylus/draft-automation-status/');
};

export const draftAutomationCreate = async (payload: any) => {
  return await authApi.post('stylus/draft-automation-status/', payload);
};

export const editDraftAutomationStatus = async (payload: any) => {
  return await authApi.patch(
    `stylus/draft-automation-status/${payload?.id}/`,
    payload?.body
  );
};
